import { useForm } from "react-hook-form";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { yupResolver } from "@hookform/resolvers/yup";
import { Suspense, useMemo, useState } from "react";
import { AdministrarPacEdit } from "../models/administrarPac";
import { useColumns } from "../utils/columns";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import InputText from "../../../../components/inputs/genericos/inputText";
import { FilterList } from "@mui/icons-material";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import ModalPac from "../components/modalPac";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";



interface FiltrosPac {
    rut: string;
    llavePac: string;
}

function AdministradorPac() {
    const [modalDetalle, setModalDetalle] = useState<boolean>(false)
    const [pacEditar, setPacEditar] = useState<AdministrarPacEdit>();
    const [isEdit, setIsEdit] = useState<boolean>(false);


    const urlTabla = `siscred-api-recaudacion/v1/pac/listar`;

    const controlTabla = useDataFetch(
        urlTabla,
        new URLSearchParams('filters.status=Activo'),
        true,
    )
    const {
        formState: { errors },
        control,
        handleSubmit,
    } = useForm<FiltrosPac>({
        mode: 'onBlur'
    })

    const { COLUMNS } = useColumns({ controlTabla, setPacEditar, setModalDetalle, isEdit: setIsEdit });

    const columns = useMemo(() => COLUMNS, [controlTabla]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Recaudacion masiva', url: `/recaudacionMasiva` },
        { label: 'Administrador PAC', active: true },
    ]

    const onSubmit = async (data: FiltrosPac) => {

        const rutLimpio = data.rut ? data.rut.replace(/\./g, '') : '';

        if (rutLimpio) {
            controlTabla.manejarCambiosFiltros('filters.rut', rutLimpio);
        } else {
            controlTabla.manejarCambiosFiltros('filters.rut', '');
        }

        if (data.llavePac) {
            controlTabla.manejarCambiosFiltros('filters.llavePac', data.llavePac.toString());
        } else {
            controlTabla.manejarCambiosFiltros('filters.llavePac', '');
        }

        await controlTabla.fetchData();
    };


    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>

                                        <Grid2 size={3}>
                                            <InputRut
                                                name="rut"
                                                control={control}
                                                label="RUT deudor"
                                                error={errors.rut}
                                            />
                                        </Grid2>
                                        <Grid2 size={3}>
                                            <InputNumber
                                                name="llavePac"
                                                control={control}
                                                label='Llave PAC'
                                                decimales={4}
                                            />
                                        </Grid2>                                        
                                        <PermissionGuard permissions={[TipoFuncionalidad.Recaudacion_ver]}>
                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                        </Grid2>
                                        </PermissionGuard>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                control={controlTabla}
                                url={urlTabla}
                                callApi={false}
                                titulo={
                                    <TableHeader
                                        title=""
                                        control={controlTabla}
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(controlTabla.data, columns, "PAC")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>


            </Suspense>
            <ModalPac
                show={modalDetalle}
                datosEditar={pacEditar}
                onHide={() => setModalDetalle(false)}
                refresh={() => controlTabla.fetchData()}
                isEditing={isEdit}
            />
        </>
    );


}

export default AdministradorPac;